<template>
  <ConfettiForestBackground>
    <main :class="$style.page">
      <div :class="$style.box">
        <img
          draggable="false"
          :class="$style.logo"
          :src="getThemeAsset('mini-games.svg')"
          alt="Mini Games"
        />
        <h1 :class="$style.title">ACCESS VERIFIED</h1>
        <p :class="$style.message">
          if you can see this, you have access to our platform!
        </p>
        <p :class="$style.verifiedAt">verified at: {{ verifiedAt }}</p>
      </div>
    </main>
  </ConfettiForestBackground>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Themes } from '../../types'
import { ConfettiForestBackground } from '../components/ConfettiForestBackground.vue'
import { useTheme } from '../utils/useTheme'

const verifiedAtFormatter = new Intl.DateTimeFormat('en-US', {
  month: '2-digit',
  day: '2-digit',
  year: 'numeric',
  hour: 'numeric',
  minute: '2-digit',
  second: '2-digit',
})

export default defineComponent({
  components: {
    ConfettiForestBackground,
  },
  setup() {
    const { getThemeAsset } = useTheme(Themes.CLASSIC)

    return {
      getThemeAsset,
      verifiedAt: verifiedAtFormatter.format(new Date()),
    }
  },
})
</script>

<style module>
.page {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  overflow: auto;
  color: rgb(var(--base-color));
}

.box {
  background: #fff;
  border-radius: 1rem;
  box-shadow: var(--interactive-strong-base-shadow-resting);
  padding: 2.5rem 3rem;
  text-align: center;
  max-width: 32rem;
  width: 100%;
}

.logo {
  width: 100%;
}

.title {
  font-size: 1.5rem;
  font-weight: 800;
  letter-spacing: 0.125rem;
  margin-bottom: 1rem;
}

.message {
  font-size: 1.125rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.verifiedAt {
  font-size: 0.875rem;
  opacity: 0.72;
}
</style>
